import React, { useEffect, useState } from 'react';
import InnerHTML from 'dangerously-set-html-content';

const ClientExample = () => {
  /* Render */
  return (
    <>
      <h1>Example page</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum.
      </p>
      <div>
        <InnerHTML style={{ height: '600px', width: '500px' }} html={test1} />
      </div>
    </>
  );
};

export default React.memo(ClientExample);

const test1 = `

<!-- Atom Widget -->
<div class="atom_widget" id="stock-container">
  <script class="atom_widget" id="stock-script" type="text/javascript" src="https://atom-packages.s3.amazonaws.com/atom-viz/embedWidgetLocalhost.js">
    {
      "widget": "stock",
      "settings": {
        "token": "d3178cec-82ae-4d8d-8ad6-2a816c447148",
        "symbol": "AAPL",
        "theme": "Light"
      }
    }
  </script>
  <div class="atom_widget" id="stock-widget"></div>
</div>
<!-- Atom Widget -->

`;
